// extracted by css-extract-rspack-plugin
export default {"Markdown":"S1gHjo0TfBo5Aw8v"};